import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const testimonials = [
    {
        id: '01',
        Des: "Un partenaire exceptionnel pour nos besoins en aluminium. La qualité des profils extrudés est remarquable et le service client irréprochable. Nous recommandons vivement leurs services pour tout projet industriel.",
        title: 'Youssef Ben Salem',
        sub: "Directeur Technique, Industries Métallurgiques SA",
        job: "Directeur Technique, Industries Métallurgiques SA",
    },
    {
        id: '02',
        Des: "Excellente collaboration sur notre projet de façades. L'équipe a su comprendre nos besoins spécifiques et livrer des produits de qualité supérieure dans les délais convenus. Professionnalisme et expertise au rendez-vous.",
        title: 'Mohamed Ben Salem',
        sub: "Chef de Projet, Construction Moderne",
        job: "Chef de Projet, Construction Moderne",
    },
    {
        id: '03',
        Des: "Leur engagement en matière de durabilité et de recyclage correspond parfaitement à nos valeurs. Des solutions innovantes et respectueuses de l'environnement pour nos équipements industriels.",
        title: 'Aymen Ben Salem',
        sub: "Responsable Achats, Groupe Industriel Européen",
        job: "Responsable Achats, Groupe Industriel Européen",
    },





]




const Testimonial = (props) => {

    const settings = {
        dots: true,
        autoplay: true,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 991,
            settings: {
                arrows: false,
                dots: true,
            }
        }

        ]
    };


    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="wpo-testimonial-wrap">
                            <Slider {...settings} className='testimonial-slider'>
                                {testimonials.map((testimonial, item) => (
                                    <div className="wpo-testimonial-item" key={item}>
                                        <div className="wpo-testimonial-top" >
                                            <div className="wpo-testimonial-img">
                                                <i className="fi flaticon-quote-1" aria-hidden="true"></i>
                                            </div>
                                            <div className="wpo-testimonial-info">
                                                <h2>{testimonial.title}</h2>
                                                <span>{testimonial.sub}</span>
                                            </div>
                                        </div>
                                        <div className="wpo-testimonial-content">
                                            <p>{testimonial.Des}</p>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;






